import { render, staticRenderFns } from "./services_page1.vue?vue&type=template&id=15ca53a8&scoped=true&"
import script from "./services_page1.vue?vue&type=script&lang=js&"
export * from "./services_page1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca53a8",
  null
  
)

export default component.exports